// O PostgREST corta respostas em 1000 linhas por padrão, SILENCIOSAMENTE —
// somas e listagens acima disso ficam erradas sem nenhum aviso. Este helper
// busca todas as linhas paginando via .range().
//
// buildQuery deve retornar uma query NOVA a cada chamada (o builder do
// supabase-js é mutável e não pode ser reaproveitado entre páginas) e precisa
// ter ordenação determinística até o desempate (ex.: .order('id') no final) —
// sem isso o banco pode repetir ou pular linhas entre páginas.
//
// PAGE_SIZE deve ser <= ao max-rows do servidor (1000 no Supabase padrão):
// pedir mais do que ele entrega faria o loop parar antes do fim.
const PAGE_SIZE = 1000;

export const fetchAllRows = async (buildQuery) => {
  const rows = [];
  for (;;) {
    const from = rows.length;
    const { data, error } = await buildQuery().range(from, from + PAGE_SIZE - 1);
    if (error) return { data: null, error };
    rows.push(...(data || []));
    if (!data || data.length < PAGE_SIZE) break;
  }
  return { data: rows, error: null };
};
